export enum AuthStatus {
    AUTHENTICATED="AUTHENTICATED",
    UNAUTHENTICATED="UNAUTHENTICATED",
    CHECKING="CHECKING"
}